export default function PaymentStatusSkeleton() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50 px-4">
      <div className="w-full max-w-md space-y-4 rounded-lg bg-white p-8 text-center shadow-sm">
        <div className="mx-auto h-8 w-56 animate-pulse rounded bg-[#F0E0C7]/60" />
        <div className="mx-auto h-4 w-full animate-pulse rounded bg-[#F0E0C7]/60" />
        <div className="mx-auto h-4 w-4/5 animate-pulse rounded bg-[#F0E0C7]/60" />
        <div className="mx-auto mt-4 h-10 w-40 animate-pulse rounded-full bg-[#F0E0C7]/60" />
      </div>
    </div>
  );
}
